export default function buttonPreloader(element) {
    function show() {
        element.parentNode.classList.add('show-btn-preloader');
    }

    function hide() {
        element.parentElement.classList.remove('show-btn-preloader');
    }

    return {
        show,
        hide,
    };
}
